import { getRoles } from "@/utils/users";

export const rolesFilter = roles => {
  return getRoles(roles);
};

export const accountTypeFilter = accountType => {
  return accountType === "worker" ? "Candidate" : "Staff";
};
